import { Table, TableProps } from "antd";
import { DataType } from "../../../models/interface/license.interface";
import { Columns } from "./Column";

const App = ({
  data,
  total,
  rowSelection,
}: {
  data: DataType[];
  total: number;
  rowSelection: TableProps<DataType>["rowSelection"];
}) => {
  return (
    <Table<DataType>
      columns={Columns}
      dataSource={data}
      rowSelection={rowSelection}
      pagination={false}
      rowKey={(record) => record.id?.toString() ?? ""}
    />
  );
};

export default App;
